<template>
  <div id="new-negotiation">
    <BreadCrumb :items="breadcrumbItems" />
    <v-card elevation="2" class="py-5 mt-1">
      <div class="header pr-5 pb-5">
        <h1>Nova Negociação</h1>
        <div class="mt10"></div>
        <p class="pl-9">Insira as informações da negociação</p>
      </div>

      <div v-if="isNegociationLoading" class="d-flex justify-center py-12">
        <v-progress-circular color="primary" indeterminate />
      </div>

      <v-form v-else @submit.prevent="submit">
        <v-row class="px-9">
          <v-col cols="12" md="3">
            <v-select v-model="type" label="Selecione o tipo" :items="types" item-text="name" item-value="id">
            </v-select>
          </v-col>

          <v-col cols="12"></v-col>

          <v-col cols="12" md="3" v-show="!type">
            <v-text-field v-model="cpfOrCnpj" label="CNPJ" v-mask="'##.###.###/####-##'"> </v-text-field>
          </v-col>

          <v-col cols="12" md="3" v-show="type">
            <v-select
              v-model="stateId"
              label="Estado (Obrigatório)"
              :items="getStates"
              item-text="name"
              item-value="id"
              @change="fetchCitiesByID"
            >
            </v-select>
          </v-col>

          <v-col cols="12" md="3" v-show="type">
            <v-select
              v-model="cityId"
              label="Cidade (Obrigatório)"
              :items="getCities"
              item-text="name"
              item-value="id"
              :disabled="!stateId"
              :loading="loadingCity"
            >
            </v-select>
          </v-col>

          <v-col cols="12"></v-col>

          <v-col cols="12" md="3">
            <v-text-field v-model="value" v-money="money" label="Valor"></v-text-field>
          </v-col>

          <MessagesError :errors="errors" @closeMessages="errors = []" />

          <v-col cols="12" class="d-flex justify-end">
            <v-btn large color="info" class="mr-5" @click="cancel()"> VOLTAR </v-btn>
            <v-btn large color="success" @click="submit()" :loading="loadingToCreate"> SALVAR </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import BreadCrumb from '../../../components/BreadCrumb.vue';
import MessagesError from '../../../components/MessagesError.vue';
import removeCaracters from '../../../utils/removeCaracters';
import removePriceMask from '@/utils/removePriceMask';
import { VMoney } from 'v-money';
export default {
  name: 'NewNegotiation',
  components: {
    BreadCrumb,
    MessagesError
  },
  directives: { money: VMoney },
  data: () => ({
    isNegociationLoading: true,
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      suffix: '',
      precision: 2,
      masked: false
    },
    types: [
      { name: 'Município', id: 1 },
      { name: 'CNPJ', id: 0 }
    ],
    value: null,
    transhipmentId: null,
    type: 1,
    cpfOrCnpj: null,
    errors: [],
    stateId: '',
    cityId: '',
    loadingCity: false,
    success: false,
    loading: false,
    loadingToCreate: false
  }),
  computed: {
    ...mapGetters('AdressStore', ['getStates', 'getCities']),
    id() {
      return this.$route.params.id;
    },
    typeRoute() {
      return this.$route.params.type;
    },
    breadcrumbItems() {
      return [
        {
          text: 'Início',
          disabled: false,
          to: '#'
        },
        {
          text: 'Transbordos',
          disabled: false,
          to: '/transhipments/',
          exact: true
        },
        {
          text: 'Negociações',
          disabled: false,
          to: '/transhipments/negotiations',
          exact: true
        },
        {
          text: 'Nova negociação',
          disabled: true
        }
      ];
    }
  },
  mounted() {
    this.fetchAllStates();

    if (this.typeRoute) {
      this.type = Number(this.typeRoute);

      this.fetchMyNegotiationByID();
    } else {
      this.isNegociationLoading = false;
    }
  },
  methods: {
    ...mapActions('AdressStore', ['fetchStates', 'fetchCities']),
    ...mapActions('TranshipmentStore', [
      'createNegotiationCity',
      'createNegotiationCNPJ',
      'fetchNegotiationByID',
      'editNegotiationCity',
      'editNegotiationCNPJ'
    ]),
    async fetchMyNegotiationByID() {
      const params = {
        type: Number(this.typeRoute),
        id: this.id
      };

      this.isNegociationLoading = true;

      try {
        const data = await this.fetchNegotiationByID(params);

        this.value = data.price * 100;
        this.cityId = data.cityId;
        this.stateId = data.stateId;
        this.transhipmentId = data.transhipmentId;

        this.loadingCity = true;
        try {
          await this.fetchCities(data.stateId);
        } catch (err) {
          console.error(err);
        } finally {
          this.loadingCity = false;
        }

        if (this.typeRoute === '0') {
          this.cpfOrCnpj = data.cpfOrCnpj;
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.isNegociationLoading = false;
      }
    },
    async fetchAllStates() {
      try {
        await this.fetchStates();
      } catch (err) {
        console.error(err);
      }
    },
    async fetchCitiesByID() {
      this.loadingCity = true;
      try {
        await this.fetchCities(this.stateId);
      } catch (err) {
        console.error(err);
      } finally {
        this.loadingCity = false;
      }
    },
    async submit() {
      this.loadingToCreate = true;
      let params = {
        transhipmentId: this.typeRoute ? this.transhipmentId : this.id,
        price: Number(removePriceMask(this.value)),
        [this.type ? 'cityId' : 'cpfOrCnpj']: this.type ? this.cityId : removeCaracters(this.cpfOrCnpj)
      };

      if (this.typeRoute) {
        params.id = this.id;
      }

      try {
        const status = this.typeRoute
          ? this.type
            ? await this.editNegotiationCity(params)
            : await this.editNegotiationCNPJ(params)
          : this.type
          ? await this.createNegotiationCity(params)
          : await this.createNegotiationCNPJ(params);

        if (status.success) {
          this.$router.back();
        } else {
          this.errors = status.errors;
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loadingToCreate = false;
      }
    },
    cancel() {
      this.$router.back();
    }
  }
};
</script>

<style lang="scss">
#new-negotiation {
  .mt-10-topo {
    position: relative;
    top: -18px;
    margin: 0;
    padding: 0;
  }
}
</style>
